// ConfirmationDialog.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

export default function ConfirmationDialog(){

  const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
  const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
  const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
  const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

  const dispatch = useDispatch(); // dispatch(
  const openConfirmationDialog = useSelector((state) => state.confirmationDialog.openConfirmationDialog);
  const noteBookmarkListItemToBeDeleted = useSelector((state) => state.confirmationDialog.noteBookmarkListItemToBeDeleted);
  const callerConfirmationDialog = useSelector((state) => state.confirmationDialog.callerConfirmationDialog);
  const dialogTitle = useSelector((state) => state.confirmationDialog.dialogTitle);
  const buttonText = useSelector((state) => state.confirmationDialog.buttonText);
  const titleToBeDeleted = useSelector((state) => state.confirmationDialog.titleToBeDeleted);
  const tabVerseListNew = useSelector((state) => state.verse.tabVerseListNew);
  const bookReadLogToBeCleared = useSelector((state) => state.profile.bookReadLogToBeCleared);

  const navigate = useNavigate();

  const handleClose = () => {
    dispatch(setOpenConfirmationDialog(false));
  };

  const handleOnClickAction = async () => {
    switch(callerConfirmationDialog){
      case 'noteBookmarkListItemToBeDeleted':
        await putNoteBookmarkListItem2('ConfirmationDialog');
        getHasNoteVersesAll(tabVerseListNew, 'ConfirmationDialog'); 
        break;
      case 'Profile':
        deleteVerseReadLogList({ book: bookReadLogToBeCleared }, 'ConfirmationDialog');
        break;     
      case 'allContext':
      case 'Signout':
        //navigate('/signout');
        dispatch(reset4SignIn());
        dispatch(reset4GoToTopButtonVisible());
        deleteLogListItem();
        navigate('/signin');          
        break;
    }  
    dispatch(setOpenConfirmationDialog(false));
  };

  return (
    <div>
      <Dialog
        open={openConfirmationDialog}
        fullWidth
      >
        <DialogTitle>
          {/* 確定刪除 */}
          {/* {dialogTitle} */}
          <Button style={{ position: 'absolute', right: 1, top: 1 }} onClick={handleClose}>
              <CloseIcon sx={{color: 'black'}}/>
          </Button> 
        </DialogTitle>

        <DialogContent>

          <DialogContentText>

            <Grid container spacing={2}>

              <Grid
                  size={12} 
                  sx={{ 
                      display: 'flex',
                      justifyContent: 'center'
                  }}
              >
                  <Alert icon={false} variant="outlined" severity='warning' sx={{ width: '100%' }}>
                      {titleToBeDeleted}
                  </Alert>
              </Grid>

              <Button
                  sx={{
                  color: 'white',
                  bgcolor: 'primary.main',
                  '&:hover': { color: 'white', backgroundColor: 'primary.main' },
                  }}
                  fullWidth
                  onClick={handleOnClickAction}
              >
                  {/* <CheckIcon /> */}
                  {buttonText}
              </Button> 

            </Grid>

          </DialogContentText>

        </DialogContent>

      </Dialog>
    </div>
  );
};